import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { useAuth } from "@clerk/clerk-react";

/**
 * Crea una función que obtiene el token de autenticación de Clerk para usarlo en las solicitudes
 * @returns {Object} Objeto con el token de autenticación si está disponible
 */
export const prepareClerkHeaders = () => {
  // Esta función debe ejecutarse en tiempo de ejecución para obtener el token actual
  // No podemos usar hooks como useAuth aquí directamente
  
  // Si window.__clerk_session_jwt existe, lo usamos (podemos almacenarlo globalmente cuando el usuario inicia sesión)
  const token = (window as any).__clerk_jwt;
  const userId = (window as any).__clerk_user_id;
  const userEmail = (window as any).__clerk_user_email;
  
  if (token && userId) {
    return {
      Authorization: `Bearer ${token}`,
      'x-clerk-user-id': userId,
      'x-clerk-email': userEmail || '',
    };
  }
  
  return {};
};

// Configuración base para las solicitudes a la API
export const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers) => {
    // Asegurar que siempre se acepte JSON en las respuestas
    headers.set("Accept", "application/json");
    
    // Agregar headers de Clerk si están disponibles
    const clerkHeaders = prepareClerkHeaders();
    Object.entries(clerkHeaders).forEach(([key, value]) => {
      headers.set(key, value);
    });
    
    return headers;
  },
  credentials: "include", // Incluir cookies en las solicitudes
});

/**
 * Función auxiliar para establecer el token y el usuario de Clerk globalmente
 * Debe llamarse después de que el usuario inicie sesión con Clerk
 */
export const setClerkAuthInfo = (token: string, userId: string, userEmail?: string) => {
  (window as any).__clerk_jwt = token;
  (window as any).__clerk_user_id = userId;
  (window as any).__clerk_user_email = userEmail || '';
};

/**
 * Función auxiliar para limpiar el token y el usuario de Clerk globalmente
 * Debe llamarse después de que el usuario cierre sesión con Clerk
 */
export const clearClerkAuthInfo = () => {
  (window as any).__clerk_jwt = null;
  (window as any).__clerk_user_id = null;
  (window as any).__clerk_user_email = null;
};
